import * as React from 'react';
import { setCookie } from 'nookies';
import { observer } from 'mobx-react';
import { PortalHtmlHead } from './PortalHtmlHead';
import { PortalBottomscripts } from './Utils/PortalBottomscripts';
import { PortalScrolltop } from './Utils/PortalScrolltop';
import { PortalFooter } from './Footer/PortalFooter';
import { PortalSubheader } from './SubHeader/PortalSubheader';
import { PortalHeaderMobile } from './HeaderMobile/PortalHeaderMobile';
import { PortalHeader } from './Header/PortalHeader';
import { UserPanel } from './UserPanel/UserPanel';
import { StoreContext } from '../utils';
import { Store } from '../store/Store';

export interface Props {
  aside: React.ReactNode;
  content: React.ReactNode;
}

@observer
export class BasicPortalStructure extends React.Component<Props, {}> {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    const { portalStore } = this.context;

    const { aside, content } = this.props;
    return (
      <>
        <PortalHtmlHead />

        <div id="kt_body" className="header-fixed header-mobile-fixed subheader-enabled aside-enabled aside-static">
          {/*begin::Main*/}
          {/*begin::Header Mobile*/}
          <PortalHeaderMobile />
          {/*end::Header Mobile*/}
          <div className="d-flex flex-column flex-root">
            {/*begin::Page*/}
            <div className="d-flex flex-row flex-column-fluid page">
              {/*begin::Wrapper*/}
              <div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
                {/*begin::Header*/}
                <PortalHeader />
                {/*end::Header*/}
                {/*begin::Content*/}
                <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                  {/*begin::Subheader*/}
                  <PortalSubheader />
                  {/*end::Subheader*/}
                  {/*begin::Entry*/}
                  <div className="d-flex flex-column-fluid">
                    {/*begin::Container*/}
                    <div className="container-fluid">
                      <div className="d-lg-flex flex-row-fluid">
                        {/*begin::Aside*/}
                        {aside && (
                          <div
                            className="aside aside-left d-flex flex-column flex-row-auto"
                            id="kt_aside"
                            style={{ left: portalStore.isAsidePanelOpen ? 0 : undefined }}
                          >
                            {/*begin::Aside Menu*/}
                            <div className="aside-menu-wrapper flex-column-fluid" id="kt_aside_menu_wrapper">
                              {/*begin::Menu Container*/}
                              <div
                                id="kt_aside_menu"
                                className="aside-menu min-h-lg-800px"
                                data-menu-vertical={1}
                                data-menu-scroll={1}
                                data-menu-dropdown-timeout={500}
                              >
                                {/*begin::Menu Nav*/}
                                <ul className="menu-nav">{aside}</ul>
                              </div>
                            </div>
                          </div>
                        )}
                        {/*end::Aside*/}
                        <div className="content-wrapper flex-row-fluid">
                          {content}
                          {/*begin::Dashboard*/}
                          {/*begin::Row*/}
                          {/*end::Row*/}
                          {/*begin::Row*/}
                          {/*end::Row*/}
                          {/*begin::Row*/}
                          {/*end::Row*/}
                          {/*begin::Row*/}
                          {/*end::Row*/}
                          {/*end::Dashboard*/}
                        </div>
                      </div>
                    </div>
                    {/*end::Container*/}
                  </div>
                  {/*end::Entry*/}
                </div>
                {/*end::Content*/}
                {/*begin::Footer*/}
                <PortalFooter />
                {/*end::Footer*/}
              </div>
              {/*end::Wrapper*/}
            </div>
            {/*end::Page*/}
          </div>
          {/*end::Main*/}
          {/* begin::User Panel*/}
          <UserPanel />
          {/* end::User Panel*/}
          {/*begin::Quick Panel*/}

          {/*end::Quick Panel*/}
          {/*begin::Chat Panel*/}

          {/*end::Chat Panel*/}
          {/*begin::Scrolltop*/}
          <PortalScrolltop />
          {/*end::Scrolltop*/}
          {/*begin::Sticky Toolbar*/}
          {/*end::Sticky Toolbar*/}
          {/*begin::Demo Panel*/}
          {/*end::Demo Panel*/}
          {/*begin::Global Config(global config for global JS scripts)*/}
          {/*end::Global Config*/}
          {/*begin::Global Theme Bundle(used by all pages)*/}
          {/*end::Global Theme Bundle*/}
          {/*begin::Page Vendors(used by this page)*/}
          {/*end::Page Vendors*/}
          {/*begin::Page Scripts(used by this page)*/}
          {/*end::Page Scripts*/}
          {/*end::Body*/}
          <PortalBottomscripts />
        </div>
      </>
    );
  }

  componentDidMount() {
    setCookie(null, 'inline', this.context.portalStore.isInIframe ? '1' : '0', {
      maxAge: 24 * 60 * 60,
      path: '/',
    });
  }
}
